// extracted by mini-css-extract-plugin
export default {"msg":"styles_msg__lvcbi","msgEmpty":"styles_msgEmpty__jMXsw"};